import { render } from "./MBPTextarea.vue?vue&type=template&id=82c1619e&scoped=true"
import script from "./MBPTextarea.vue?vue&type=script&lang=js"
export * from "./MBPTextarea.vue?vue&type=script&lang=js"

import "./MBPTextarea.vue?vue&type=style&index=0&id=82c1619e&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c1619e"]])

export default __exports__